<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Additional notes for the Pro</strong>
      </div>
      <NotesDialog v-if="request.is_valid" :customer_request="request"/>
    </template>

    {{ request.notes }}
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import NotesDialog from '../dialogs/Notes.vue'

  export default {
    name: 'NotesSection',

    components: { Section, NotesDialog },

    props: {
      request: { type: Object, required: true, },
    },
  }

</script>
